module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-primary"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('ul', {
    staticClass: "todo-list"
  }, [_c('li', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Design a nice theme")]), _vm._v(" "), _c('small', {
    staticClass: "label label-danger"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 2 mins")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Make the theme responsive")]), _vm._v(" "), _c('small', {
    staticClass: "label label-info"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 4 hours")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Let theme shine like a star")]), _vm._v(" "), _c('small', {
    staticClass: "label label-warning"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 1 day")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Let theme shine like a star")]), _vm._v(" "), _c('small', {
    staticClass: "label label-success"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 3 days")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Check your messages and notifications")]), _vm._v(" "), _c('small', {
    staticClass: "label label-primary"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 1 week")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])]), _vm._v(" "), _c('li', [_c('input', {
    attrs: {
      "type": "checkbox",
      "value": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "text"
  }, [_vm._v("Let theme shine like a star")]), _vm._v(" "), _c('small', {
    staticClass: "label label-default"
  }, [_c('i', {
    staticClass: "fa fa-clock-o"
  }), _vm._v(" 1 month")]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('i', {
    staticClass: "fa fa-edit"
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-trash-o"
  })])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d177e5e6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VACheckList.vue
// module id = 756
// module chunks = 0